import files from "./files";

export const FILES_NAMESPACE = "files";

export default files;
